<modal #modal (onClose)="close()" [closeButtonText]="_appService.CoreCommonLiterals.ButtonClose">
  <modal-header *ngIf="_gearAppService.GearCommonLiterals">{{_gearAppService.GearCommonLiterals.Camera}}</modal-header>
  <modal-content>
    <div class="embed-responsive embed-responsive-4by3">
      <div class="loader-spiner">
        <i class="fas fa-circle-notch fa-spin fa-2x"></i>
      </div>
      <img [style.opacity]="(visible == 1 || visible === null) ? 1 : 0" [src]="urlCamera" (load)="onLoad(1)" (error)="onError(1, urlCamera)" class="img-fluid embed-responsive-item"/>
      <img [style.opacity]="(visible == 2) ? 1 : 0" [src]="urlCamera2" (load)="onLoad(2)" (error)="onError(2, urlCamera2)" class="img-fluid embed-responsive-item"/>
    </div>        
  </modal-content>
</modal>